'use strict';

module.exports = ['$http',
    function ($http) {

        return {
            restrict: 'E',
            scope: {
                form: '=',
                name: '=',
                title: '=',
                model: '=',
                options: '=',
                details: '=',
            },
            templateUrl: '/partial/app.directives.snapchat_user',
            link: function (scope, element, attributes) {
                //TODO: API Call
                scope.checkUsername = () => {
                    //TODO: API Call
                }
            }
        };
    }
];

